<template>
  <button class="rate-btn" :class="positionClass" @click="$emit('click', $event)">
    Rate this place
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"/>
      <polyline points="12 5 19 12 12 19"/>
    </svg>
  </button>
</template>

<script>
// One source of truth for the "Rate this place" CTA button. Previously this
// markup lived in two spots in HouseReviewScore.vue (desktop action row +
// mobile CTA block) and the copies kept drifting apart on label/icon tweaks.
// The optional `position` prop is just a CSS-class hook so the existing
// `.mobile-rate-btn` / desktop styling can keep working without forking the
// SVG markup.
export default {
  name: 'RateThisPlaceButton',
  props: {
    position: { type: String, default: '' }, // '' (desktop) | 'mobile-rate-btn'
  },
  computed: {
    positionClass() { return this.position; },
  },
};
</script>
